const DamFolderTypes = {
  DAM_PRODUCT_FOLDER_SET_FILTER_SORT_DATA: 'DAM_PRODUCT_FOLDER_SET_FILTER_SORT_DATA',
  DAM_PRODUCT_FOLDER_FILES_SET_FILTER_SORT_DATA: 'DAM_PRODUCT_FOLDER_FILES_SET_FILTER_SORT_DATA',
  SET_PRODUCT_FOLDERS: 'SET_PRODUCT_FOLDERS',
};

export default DamFolderTypes;
